export default __webpack_public_path__ + "static/media/meme-favicon.070f791b.png";